import React from "react";

export const ArrowLeftIcon = ({
  strokeWidth = 2,
  size = "24",
  cursor = "pointer",
  color = "#1E22FF",
  direction = "left"
}) => {
  const getRotation = () => {
    switch (direction) {
      case "right":
        return "rotate(180deg)";
      case "up":
        return "rotate(90deg)";
      case "down":
        return "rotate(270deg)";
      default:
        return "rotate(0deg)";
    }
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        cursor,
        transform: getRotation()
      }}
    >
      <path d="M20 12H4M4 12L10 18M4 12L10 6" />
    </svg>
  );
};
